<template>
  <div id="contact-create" class="row">
    <form id="create-contact-form" class="small-12 medium-5 columns" @submit.prevent="submitForm">
      <label>
        {{ 'Contact ID'|t }}
        <input type="text" ref="id" v-model="id" placeholder="3-16" required="required" pattern=".{3,16}" autofocus />
      </label>

      <label>
        {{ 'Name'|t }}
        <input type="text" v-model="name" :placeholder="'Name'|t" required="required" maxlength="128" />
      </label>

      <label>
        {{ 'Organization'|t }}
        <input type="text" v-model="org" :placeholder="'Organization'|t" />
      </label>

      <label>
        {{ 'Street'|t }}
        <input type="text" v-model="street" :placeholder="'Street'|t" required="required" />
      </label>

      <label>
        {{ 'Postal code'|t }}
        <input type="text" v-model="postcode" placeholder="1-16" required="required" pattern=".{1,16}" />
      </label>

      <label>
        {{ 'City'|t }}
        <input type="text" v-model="city" :placeholder="'City'|t" required="required" />
      </label>

      <label>
        {{ 'Country'|t }}
        <input type="text" v-model="country" placeholder="LL" required="required" pattern=".{2}" />
      </label>

      <label>
        {{ 'State'|t }}
        <input type="text" v-model="state" maxlength="64" />
      </label>

      <label>
        {{ 'E-mail address'|t }}
        <input type="email" v-model="email" :placeholder="'E-mail address'|t" required="required" />
      </label>

      <label>
        {{ 'Telephone'|t }}
        <input type="tel" v-model="telephone" placeholder="+NNN.NNNNNNNNNNNNNN" required="required" pattern="\+\d{1,3}\.\d{1,14}" />
      </label>

      <label>
        {{ 'Fax'|t }}
        <input type="tel" v-model="fax" placeholder="+NNN.NNNNNNNNNNNNNN" required="required" pattern="\+\d{1,3}\.\d{1,14}" />
      </label>

      <label>
        {{ 'Authentication password'|t }}
        <input type="text" v-model="auth" :placeholder="'Authentication password'|t" required="required" />
      </label>

      <label>
        {{ 'IDNum'|t }}
        <input type="text" v-model="idnum" placeholder="0 / 5-20" pattern=".{0}|.{5,20}" />
      </label>

      <label>
        {{ 'VAT'|t }}
        <input type="text" v-model="vat" placeholder="0 / 5-20" pattern=".{0}|.{5,20}" />
      </label>

      <label>
        {{ 'Birth date'|t }}
        <input type="date" v-model="birthdate" />
      </label>


      <fieldset class="fieldset">
        <legend>Disclose</legend>
        <label><input type="checkbox" v-model="disclose_name" /> Name</label>
        <label><input type="checkbox" v-model="disclose_org" /> Organization</label>
        <label><input type="checkbox" v-model="disclose_addr" /> Address</label>
        <label><input type="checkbox" v-model="disclose_voice" /> Telephone</label>
        <label><input type="checkbox" v-model="disclose_fax" /> Fax</label>
        <label><input type="checkbox" v-model="disclose_email" /> E-mail</label>
      </fieldset>
      <input type="submit" name="submit" :value="'Submit'|t" class="medium expanded success button" />
    </form>
  </div>
</template>

<script>
  import api from '@/api';
  import router from '@/routes';

  export default {
    name: 'CreateForm',
    data() {
      return {
        id: null,
        name: null,
        org: null,
        street: null,
        postcode: null,
        city: null,
        country: null,
        state: null,
        email: null,
        telephone: null,
        fax: null,
        auth: null,
        idnum: null,
        vat: null,
        birthdate: null,
        disclose_name: null,
        disclose_org: null,
        disclose_addr: null,
        disclose_voice: null,
        disclose_fax: null,
        disclose_email: null
      }
    },
    methods: {
      submitForm() {
        let request = {
          contact_id: this.id,
          org: this.org,
          name: this.name,
          street: this.street,
          city: this.city,
          state: this.state,
          postcode: this.postcode,
          country: this.country,
          email: this.email,
          telephone: this.telephone,
          fax: this.fax,
          authinfo: this.auth,
          disclose_name: this.disclose_name === true,
          disclose_org: this.disclose_org === true,
          disclose_addr: this.disclose_addr === true,
          disclose_voice: this.disclose_voice === true,
          disclose_fax: this.disclose_fax === true,
          disclose_email: this.disclose_email === true,
          idnum: this.idnum,
          vat: this.vat,
          birthdate: this.birthdate
        };

        api.createContact(
          request,
          data => {
            ctx.commit('messages/addMessage', {
              type: "status",
              message: "Contact %s has been created.",
              args: [data.contact_id]
            }, {root: true});
            router.push({name: 'contact.collection'});
          }
        );
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/contact/CreateForm.vue